import Location from "../../PersonalInformation/CurrentLocation";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export function CurrentLocation({ searchObject, setSearchObject, t }) {
  return (
    <>
      <div>
        <Location
          setCurrentLocation={setSearchObject}
          currentLocation={searchObject}
        />
      </div>
    </>
  );
}
